export const EVENT_KEYS = {
  ENTER: 'Enter',
  BACKSPACE: 'Backspace',
};
